class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/default`;
    }
    /**
     * Assigns the default role to the currently logged-in user extension.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/assigned-role/default
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: Users
     */
    async put(restRequestConfig) {
        const r = await this.rc.put(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
